/* FLOW-29 (28 Oct 2026): fewer steps from "Start my cleanse" to checkout.
   Loaded from layout/theme.liquid, before presscription.js.

   1. Cleanses go straight to /cart. Every buy button in the theme adds with
      fetch('/cart/add.js') and then fires theme:cartchanged (openDrawer: true
      on the buy buttons). This file reads each successful add's response; when
      it holds a cleanse (product type or title contains "cleanse", the same
      rule as snippets/atc28-label) and the page is not the cart, the next
      theme:cartchanged does not open the drawer and the shopper is taken to
      /cart, where the postcode + start date step and Checkout are. It waits
      until no cart request is still running, so anything added in the same
      click (boost24 add-ons, subscriptions, line item properties) is in the
      cart first. Nothing is added here, so nothing can be added twice.
   2. Everything else keeps the drawer, once. The first add of a non-cleanse
      in a browser session opens the drawer as before. After that an add does
      not fly the drawer out again: the header count updates (as it always
      did) and a short "Added to your cart · View cart" note shows instead.
   3. Build-a-box lines (property _pbx) never open the drawer; the box's own
      tray and Checkout button carry that flow (MOB-23).
   4. UPSELL-ATC (28 Oct): an add from an add-on / upsell tile (press-upsell
      in the drawer or on /cart, upsell26 rows and sheets) never redirects.
      A cleanse added from the drawer's "Complete your order" keeps the
      shopper in the drawer; the tile refreshes the cart itself.

   Undo: delete the flow29.js script tag in layout/theme.liquid. */
(function () {
  if (window.__flow29) return;
  window.__flow29 = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART = ROOT + 'cart';
  var WINDOW_MS = 10000;      /* an add is "recent" for this long */
  var FALLBACK_MS = 3500;     /* go to /cart even if no event comes */
  var SEEN_KEY = 'flow29:drawer-seen';

  var last = null;            /* { kind: 'cleanse'|'single'|'box', t } */
  var inflight = 0;
  var navPending = false, navTimer = null, fallbackTimer = null;
  var upsellAt = 0;           /* last click on an add-on / upsell tile button */

  /* capture phase, so it is set before the tile's own click handler fetches */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-pup-add],[data-u26-quick],[data-u26-add]')) upsellAt = Date.now();
  }, true);

  function onCartPage() {
    return !!(document.body && /(^|\s)template-cart(\s|$)/.test(document.body.className)) ||
      /\/cart\/?$/.test(location.pathname);
  }
  function isCleanse(it) {
    return /cleanse/i.test((it.product_type || '') + ' ' + (it.product_title || it.title || ''));
  }
  function kindOf(json) {
    var items = json && (json.items || (json.id ? [json] : null));
    if (!items || !items.length) return null;
    var box = false, cleanse = false;
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties || {};
      if (p._pbx) box = true;
      if (isCleanse(items[i])) cleanse = true;
    }
    if (box) return 'box';
    return cleanse ? 'cleanse' : 'single';
  }
  function recent() { return last && Date.now() - last.t < WINDOW_MS ? last : null; }
  function seen() { try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return !!window.__flow29Seen; } }
  function markSeen() { window.__flow29Seen = true; try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {} }

  /* ---------- navigation to /cart ---------- */
  function go() {
    clearTimeout(fallbackTimer);
    if (inflight > 0) { navPending = true; return; }
    navPending = false;
    clearTimeout(navTimer);
    navTimer = setTimeout(function () {
      if (inflight > 0) { navPending = true; return; }
      last = null;
      window.location.assign(CART);
    }, 120);
  }

  /* ---------- fetch: watch cart requests ---------- */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (!/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) return p;
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      inflight++;
      function done() {
        inflight = Math.max(0, inflight - 1);
        if (inflight === 0 && navPending) go();
      }
      return p.then(function (res) {
        if (!isAdd || !res || !res.ok) { done(); return res; }
        var copy;
        try { copy = res.clone(); } catch (e) { done(); return res; }
        return copy.json().then(function (j) {
          var k = kindOf(j);
          if (k === 'cleanse' && Date.now() - upsellAt < WINDOW_MS) k = 'upsell';
          if (k) {
            last = { kind: k, t: Date.now() };
            if (k === 'cleanse' && !onCartPage()) {
              clearTimeout(fallbackTimer);
              fallbackTimer = setTimeout(function () {
                if (last && last.kind === 'cleanse') go();
              }, FALLBACK_MS);
            }
          }
          done();
          return res;
        }, function () { done(); return res; });
      }, function (err) { done(); throw err; });
    };
  }

  /* ---------- the drawer decision ----------
     Window, capture phase: runs before presscription.js and every other
     listener. The event keeps going (header counts and the drawer contents
     still refresh); only detail.openDrawer is changed. */
  window.addEventListener('theme:cartchanged', function (e) {
    var r = recent();
    if (r && r.kind === 'upsell') { last = null; return; }
    if (!r || onCartPage()) return;
    var d = e.detail && typeof e.detail === 'object' ? e.detail : null;
    if (r.kind === 'cleanse') {
      if (d) d.openDrawer = false;
      go();
      return;
    }
    if (!d || !d.openDrawer) return;
    if (r.kind === 'box') { d.openDrawer = false; return; }
    /* single product */
    if (!seen()) { markSeen(); last = null; return; }
    d.openDrawer = false;
    last = null;
    toast();
  }, true);

  /* back/forward cache: a page restored after leaving for /cart starts clean */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    last = null; navPending = false; inflight = 0;
    clearTimeout(navTimer); clearTimeout(fallbackTimer);
  });

  /* ---------- "Added" note ---------- */
  var toastEl = null, toastTimer = null;
  function toast() {
    if (!document.body) return;
    if (!toastEl) {
      var st = document.createElement('style');
      st.textContent =
        '.f29-toast{position:fixed;left:50%;bottom:calc(96px + env(safe-area-inset-bottom,0px));z-index:2147482000;' +
        'transform:translate(-50%,12px);opacity:0;pointer-events:none;transition:opacity .18s ease,transform .18s ease;' +
        'display:flex;align-items:center;gap:14px;max-width:calc(100vw - 32px);box-sizing:border-box;padding:12px 16px;' +
        'border-radius:12px;background:#14163a;color:#fff;font-family:inherit;font-weight:600;font-size:14px;line-height:1.3;box-shadow:0 8px 24px rgba(20,22,58,.25)}' +
        '.f29-toast.is-on{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
        '.f29-toast a{color:#fff;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}' +
        '.f29-toast svg{flex:0 0 auto}' +
        '@media (min-width:750px){.f29-toast{bottom:24px}}' +
        '@media (prefers-reduced-motion:reduce){.f29-toast{transition:none}}' +
        '@keyframes f29bump{0%{transform:scale(1)}40%{transform:scale(1.35)}100%{transform:scale(1)}}' +
        '.f29-bump{animation:f29bump .45s ease}';
      document.head.appendChild(st);
      toastEl = document.createElement('div');
      toastEl.className = 'f29-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' +
        '<span>Added to your cart</span><a href="' + CART + '">View cart</a>';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.remove('is-on');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
    setTimeout(function () {
      var els = document.querySelectorAll('[data-cart-count], .cart-link__count');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove('f29-bump'); void els[i].offsetWidth; els[i].classList.add('f29-bump');
      }
    }, 600);
  }
})();
